import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useFetchCart from '@nike/shop-apis/buy/carts/v2/fetch/use-query';
import ItemPriceBase from "../base/ItemPriceBase";
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";

/**
 * Cart-specific price component that fetches price data from cart items.
 */
var CartItemPrice = function CartItemPrice() {
  var $ = _c(8);
  var itemId_0 = useItemAddedModalStore(_temp);
  var t0;
  if ($[0] !== itemId_0) {
    t0 = {
      select: function select(cart) {
        var _cart$items;
        var item_0 = (cart === null || cart === void 0 || (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.find(function (item) {
          return item.id === itemId_0;
        })) || {};
        var priceInfo = item_0.priceInfo,
          giftCard = item_0.giftCard;
        if (!priceInfo && !giftCard) {
          return {};
        }
        return {
          currency: cart === null || cart === void 0 ? void 0 : cart.currency,
          giftCardAmount: giftCard === null || giftCard === void 0 ? void 0 : giftCard.amount,
          fullPrice: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fullPrice,
          price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price,
          discount: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.discount
        };
      }
    };
    $[0] = itemId_0;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var _useFetchCart = useFetchCart(t0),
    t1 = _useFetchCart.data;
  var currency = t1.currency,
    giftCardAmount = t1.giftCardAmount,
    fullPrice = t1.fullPrice,
    price = t1.price,
    discount = t1.discount;
  if (!fullPrice && !giftCardAmount) {
    return null;
  }
  var t2;
  if ($[2] !== currency || $[3] !== discount || $[4] !== fullPrice || $[5] !== giftCardAmount || $[6] !== price) {
    t2 = /*#__PURE__*/React.createElement(ItemPriceBase, {
      currency: currency,
      fullPrice: fullPrice,
      price: price,
      discount: discount,
      giftCardAmount: giftCardAmount
    });
    $[2] = currency;
    $[3] = discount;
    $[4] = fullPrice;
    $[5] = giftCardAmount;
    $[6] = price;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default CartItemPrice;
function _temp(t0) {
  var itemId = t0.itemId;
  return itemId;
}